import { render, staticRenderFns } from "./AlcorTabs.vue?vue&type=template&id=1719ba94&lang=pug"
import script from "./AlcorTabs.vue?vue&type=script&lang=js"
export * from "./AlcorTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports